module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLightItalic.792d93c.ttf";